import React from "react";
import { Users } from "lucide-react";
import GlobalDetailDrawer from "modules/swiftboard/components/GlobalDetailDrawer";
import LocalDateTime from "services/date-converter";
import ActiveBadge from "../../../components/ActiveBadge";
import JsonBlock from "../../../components/JsonBlock";
import { EMAIL_ONLY_TYPES } from "../features/recipient-type.constants";
import { triggersText } from "../features/recipient-type.utils";

// Read-only view of one recipient type (a row of the list).
export default function RecipientTypeViewDrawer({ record, onClose }) {
  const sections = [
    {
      title: "Recipient type",
      fields: [
        { label: "Name", value: record.name || "—" },
        { label: "Key", value: <span className="font-mono">{record.type_key}</span> },
        { label: "Needs the subject", value: record.needs_subject ? "Yes" : "No" },
        { label: "Channels", value: EMAIL_ONLY_TYPES.includes(record.type_key) ? "Email only" : "Any" },
        { label: "Trigger types", value: triggersText(record.allowed_triggers) },
        { label: "Sort order", value: record.sort_order ?? 0 },
        { label: "Status", value: <ActiveBadge active={record.is_activated} /> },
        { label: "Updated", value: record.updated_date ? <LocalDateTime utcTime={record.updated_date} /> : "—" },
        { label: "Description", value: record.description || "—" },
      ],
    },
    { title: "Config schema (what a rule step provides)", fields: [{ value: <JsonBlock value={record.config_schema} /> }] },
  ];

  return <GlobalDetailDrawer open onClose={onClose} title={record.name || "Recipient type"} subtitle={record.type_key} icon={<Users size={20} />} sections={sections} />;
}
